module.exports = require("core-js/modules/es.regexp.to-string.js");